import { listItemEstablecimiento } from '../js/cart-sessionstorage/cart-sessionstorage.js';
export default {
  methods: {
    getEstablecimiento(idEstablecimiento) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var idEstablecimientoParam = app.view.main.router.currentRoute.params.idEstablecimiento;
      var idMesaParam = app.view.main.router.currentRoute.params.idMesa;
      var tipoEnvio = sessionStorage.getItem('_tipoenvio');
      var url = window.global.url + "establecimientos/" + idEstablecimiento;
      var urlImagen = window.global.url + "imagen/establecimiento/" + idEstablecimiento + "/";
      app.preloader.show();
      app.request.getJSON(url, function (data) {
        if (data.status == 'success') {
          // console.log(data);
          let establecimiento = data.establecimiento;
          localStorage.setItem('_establecimiento', JSON.stringify(establecimiento));

          if (establecimiento.estado == 1 && establecimiento.configuracion.desactivar_menu == 0) {
            self.getItemsDestacados(idEstablecimientoParam, idMesaParam);
            self.getCategorias(idEstablecimientoParam, idMesaParam);
            $('.nombre-establecimiento').text(establecimiento.nombre);

            if (establecimiento.imagen) {
              urlImagen = $('.page[data-name="principal-menu"] .img-establecimiento').attr('src', urlImagen.concat(establecimiento.imagen));
            } else {
              urlImagen = $('.page[data-name="principal-menu"] .img-establecimiento').attr('src', 'static/image-placeholder.png');
            }

            if (establecimiento.mensaje) {
              $('.mensaje-text').html('<p>' + establecimiento.mensaje + '</p>');
            }

            if (establecimiento.direccion && !establecimiento.configuracion.ocultar_direccion) {
              $('.direccion-text').append('<p><i class="icon material-icons md-only">place</i><i class="icon f7-icons ios-only">map_pin</i><a href="https://www.google.com/maps/search/?api=1&query=' + establecimiento.direccion + '" target="_blank" class="item-link item-content link external">' + establecimiento.direccion + '</a></p>');
            }

            if (establecimiento.horarios && !establecimiento.configuracion.ocultar_horarios) {
              $('.horarios-text').append('<p><i class="icon material-icons md-only">schedule</i><i class="icon f7-icons ios-only">clock</i> ' + establecimiento.horarios + '</p>');
            }

            if (tipoEnvio == 'en-el-lugar') {
              $('.en-el-lugar-chip').removeClass('display-none');
            }

            if (tipoEnvio == 'takeaway') {
              $('.takeaway-chip').removeClass('display-none');
            }

            if (tipoEnvio == 'delivery') {
              $('.delivery-chip').removeClass('display-none');
            }

            if (tipoEnvio == 'en-el-lugar' && establecimiento.configuracion.mensaje_en_el_lugar) {
              $('.mensaje-tipoenvio-text').html('<p>' + establecimiento.configuracion.mensaje_en_el_lugar + '</p>');
            }

            if (tipoEnvio == 'takeaway' && establecimiento.configuracion.mensaje_takeaway) {
              $('.mensaje-tipoenvio-text').html('<p>' + establecimiento.configuracion.mensaje_takeaway + '</p>');
            }

            if (tipoEnvio == 'delivery' && establecimiento.configuracion.mensaje_delivery) {
              $('.mensaje-tipoenvio-text').html('<p>' + establecimiento.configuracion.mensaje_delivery + '</p>');
            }
          } else if (establecimiento.estado == 1 && establecimiento.configuracion.desactivar_menu == 1) {
            app.views.main.router.navigate({
              name: 'carta-no-disponible',
              params: {
                idEstablecimiento: idEstablecimientoParam,
                idMesa: idMesaParam
              }
            });
          } else if (establecimiento.estado != 1) {
            app.views.main.router.navigate({
              path: '/'
            });
          }
        } else if (data.code == 404) {
          app.views.main.router.navigate({
            path: '/'
          });
        }

        app.preloader.hide();
      }, function (xhr, status) {
        console.log(xhr);
        console.log(status);
        app.preloader.hide();
        app.dialog.alert("Error establecimiento.");
      });
    },

    // getMesa(idMesa) {
    //     var self = this;
    //     var app = self.$app;
    //     var $ = self.$;
    //     var url = window.global.url + "mesa/" + idMesa;
    //     app.preloader.show();
    //     app.request.getJSON(url, function(data) {
    //             if (data.status == 'success') {
    //                 // console.log(data);
    //                 let mesa = data.mesa;
    //                 sessionStorage.setItem('_mesa', JSON.stringify(mesa));
    //                 app.preloader.hide();
    //             } else {
    //                 app.preloader.hide();
    //                 app.dialog.alert(data.message);
    //             }
    //             app.preloader.hide();
    //         },
    //         function(xhr, status) {
    //             console.log(xhr);
    //             console.log(status);
    //             app.preloader.hide();
    //             app.dialog.alert("Error mesa.");
    //         });
    // },
    getItemsDestacados(idEstablecimiento, idMesa) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      let establecimiento = JSON.parse(localStorage.getItem('_establecimiento'));
      var url = window.global.url + "items/destacados/establecimiento/" + idEstablecimiento;
      var urlImagen = window.global.url + "imagen/item/";
      app.preloader.show();
      app.request.getJSON(url, function (data) {
        if (data.status == 'success') {
          let cantidad_items_destacados = data.items_destacados.length;
          let slidesPerView = 1;

          if (cantidad_items_destacados > 0) {
            for (var i = 0; i < data.items_destacados.length; i++) {
              let urlItem = 'item/' + data.items_destacados[i].id_item;
              let itemDestacadoTemplate = '<a href="' + urlItem + '" class="swiper-slide">' + '<div class="swiper-slide" style="background-image:url(' + urlImagen + data.items_destacados[i].id_item + '/' + data.items_destacados[i].imagen + ')">' + '<div class="text-wrap text-shadow padding">' + data.items_destacados[i].nombre + '</div>' + '</div>' + '</a>';

              if (establecimiento.configuracion.ocultar_nombres_productos_destacados) {
                itemDestacadoTemplate = '<a href="' + urlItem + '" class="swiper-slide">' + '<div class="swiper-slide" style="background-image:url(' + urlImagen + data.items_destacados[i].id_item + '/' + data.items_destacados[i].imagen + ')">' + '</div>' + '</a>';
              }

              $('.swiper-destacados').append(itemDestacadoTemplate);
            }

            $('.block-title-destacados').removeClass('display-none');
            $('.swiper-container').removeClass('display-none');

            if (cantidad_items_destacados == 1) {
              slidesPerView = 1;
            } else {
              slidesPerView = 2;
            }

            var swiper = app.swiper.create('.swiper-container', {
              speed: 400,
              spaceBetween: 20,
              slidesPerView: slidesPerView,
              pagination: {
                "el": ".swiper-pagination"
              }
            });
          }

          app.preloader.hide();
        } else {
          app.preloader.hide();
          app.dialog.alert(data.message);
        }
      }, function (xhr, status) {
        console.log(xhr);
        console.log(status);
        app.preloader.hide();
        app.dialog.alert("Error ítems destacados.");
      });
    },

    getCategorias(idEstablecimiento, idMesa) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var url = window.global.url + "categorias/superiores/habilitadas/establecimiento/" + idEstablecimiento;
      var urlImagen = window.global.url + "imagen/categoria/";
      app.preloader.show();
      app.request.json(url, function (response) {
        if (response.code == 200) {
          let establecimiento = JSON.parse(localStorage.getItem('_establecimiento'));
          let categorias = response.categorias;

          for (let i = 0; i < categorias.length; i++) {
            const categoria = categorias[i];
            let categoriaTemplate = '<div class="col-50 large-50 xlarge-33">' + '<a href="categoria/' + categoria.id_categoria + '/items/">' + '<div class="card demo-card-header-pic elevation-4" style="background-image:url(' + urlImagen + '' + categoria.id_categoria + '/' + categoria.imagen + ')">' + '<div class="card-header align-items-flex-end">' + '<h3 class="text-shadow text-wrap-categoria">' + categoria.nombre + '</h3>' + '</div>' + '</div>' + '</a>' + '</div>';

            if (establecimiento.configuracion.vista_clasica_categorias) {
              categoriaTemplate = '<div class="col-100">' + '<a href="categoria/' + categoria.id_categoria + '/items/">' + '<div class="card elevation-4">' + '<div class="card-header align-items-flex-center">' + '<h3 class="text-color-black">' + categoria.nombre + '</h3>' + '<div class="item-after">' + '<i class="icon f7-icons text-color-gray">chevron_right</i>' + '</div>' + '</div>' + '</div>' + '</a>' + '</div>';
            }

            $('.vl-categorias').append(categoriaTemplate);
          }

          if (establecimiento.configuracion.ocultar_nombre_categorias) {
            $('.card .card-header .text-wrap-categoria').empty();
          }
        }

        app.preloader.hide();
      }, function (xhr, status) {
        console.log(xhr);
        console.log(status);
        app.preloader.hide();
        app.dialog.alert("Error categorías.");
      });
    },

    buscar() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var idEstablecimientoParam = app.view.main.router.currentRoute.params.idEstablecimiento;
      var idMesaParam = app.view.main.router.currentRoute.params.idMesa;
      let query = $('.buscar-input').val();

      if (query !== "") {
        app.views.main.router.navigate({
          name: 'search-results',
          params: {
            idEstablecimiento: idEstablecimientoParam,
            idMesa: idMesaParam,
            query: query
          }
        });
      }
    },

    mostrarCarrito() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      let currentRouteName = app.view.main.router.currentRoute.name;
      var idEstablecimientoParam = app.view.main.router.currentRoute.params.idEstablecimiento;
      let tipoEnvio = sessionStorage.getItem('_tipoenvio');
      let establecimiento = JSON.parse(localStorage.getItem('_establecimiento'));
      let desactivarCarritoEnElLugar = 0;
      let desactivarCarritoTakeaway = 0;
      let desactivarCarritoDelivery = 0;
      let desactivarCarritoEnvioPersonalizado = 0;

      if (localStorage.getItem('_establecimiento')) {
        desactivarCarritoEnElLugar = establecimiento.configuracion.desactivar_carrito_en_el_lugar;
        desactivarCarritoTakeaway = establecimiento.configuracion.desactivar_carrito_takeaway;
        desactivarCarritoDelivery = establecimiento.configuracion.desactivar_carrito_delivery;
        desactivarCarritoEnvioPersonalizado = establecimiento.configuracion.desactivar_carrito_envio_personalizado;
      }

      if ($('.cart-fab').hasClass("display-none") && tipoEnvio == "en-el-lugar" && desactivarCarritoEnElLugar == 0) {
        $('.cart-fab').removeClass("display-none");
      }

      if ($('.cart-fab').hasClass("display-none") && tipoEnvio == "takeaway" && desactivarCarritoTakeaway == 0) {
        $('.cart-fab').removeClass("display-none");
      }

      if ($('.cart-fab').hasClass("display-none") && tipoEnvio == "delivery" && desactivarCarritoDelivery == 0) {
        $('.cart-fab').removeClass("display-none");
      }

      if ($('.cart-fab').hasClass("display-none") && tipoEnvio == "personalizado" && desactivarCarritoEnvioPersonalizado == 0) {
        $('.cart-fab').removeClass("display-none");
      }
    }

  },
  on: {
    pageBeforeIn() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var idEstablecimientoParam = app.view.main.router.currentRoute.params.idEstablecimiento;
      let itemList = listItemEstablecimiento(idEstablecimientoParam);
      self.mostrarCarrito(); // if (itemList.length > 0) {
      //     let cantidad_total = 0;
      //     for (let i = 0; i < itemList.length; i++) {
      //         const element = itemList[i].quantity;
      //         cantidad_total += element;
      //     }
      //     $('.cart-icon').append($('<span class="badge-carrito badge color-red">' + cantidad_total + '</span>'));
      // }
      // if (itemList.length == 0) {
      //     $('.badge-carrito').remove();
      // }
    },

    pageInit() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var idEstablecimientoParam = app.view.main.router.currentRoute.params.idEstablecimiento;
      var idMesaParam = app.view.main.router.currentRoute.params.idMesa;
      self.getEstablecimiento(idEstablecimientoParam);
      sessionStorage.removeItem('_mesa');

      if (idMesaParam != 0) {
        // self.getMesa(idMesaParam);
        sessionStorage.setItem('_mesa', idMesaParam);
      }

      $('.buscar-button').on('click', function () {
        self.buscar();
      }); // $('.cart-fab').on('click', function() {
      //     let itemList = listItemEstablecimiento(idEstablecimientoParam);
      //     if (itemList.length > 0) {
      //         app.views.main.router.navigate({
      //             name: 'cart',
      //             params: {
      //                 idEstablecimiento: idEstablecimientoParam,
      //                 idMesa: idMesaParam
      //             }
      //         });
      //     } else {
      //         app.dialog.alert("El carrito está vacío.<br>Agregá algo al carrito para continuar.");
      //     }
      // });
    }

  },
  id: '2fa2c3700e',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=principal-menu><div class=navbar><div class=navbar-bg></div><div class=navbar-inner><div class="left sliding"><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Atrás</span></a></div><div class="title nombre-establecimiento sliding"></div><div class=right><a class="link icon-only searchbar-enable" data-searchbar=.searchbar><i class="icon f7-icons if-not-md">search</i> <i class="icon material-icons md-only">search</i> </a><a class="link popover-open" href=# data-popover=.popover-links><i class="icon material-icons md-only">more_vert</i> <i class="icon f7-icons ios-only">ellipsis_vertical</i></a></div><!-- Searchbar is a direct child of "navbar-inner" --><form data-search-container=.buscar-input class="searchbar searchbar-expandable searchbar-init"><div class=searchbar-inner><div class=searchbar-input-wrap><input type=search class=buscar-input placeholder=Buscar> <i class=searchbar-icon></i> <span class="input-clear-button buscar-button"></span></div><span class="searchbar-disable-button buscar-button if-not-aurora">Buscar</span></div></form></div></div><div class=page-content><!-- Searchbar backdrop --><div class=searchbar-backdrop></div><div class="block text-align-center"><img class=img-establecimiento></div><div class="block text-align-center"><div class=mensaje-text></div><div class=direccion-text></div><div class=horarios-text></div><div class="chip en-el-lugar-chip display-none"><div class=chip-label>En el lugar</div></div><div class="chip takeaway-chip display-none"><div class=chip-label>Take away</div></div><div class="chip delivery-chip display-none"><div class=chip-label>Delivery</div></div><div class=mensaje-tipoenvio-text></div></div><div class="row justify-content-center"><div class="col-100 medium-100 large-50"><div class="block-title block-title-destacados display-none">Destacados</div><div class="swiper-container swiper-items-destacados demo-swiper display-none"><div class=swiper-pagination></div><div class="swiper-wrapper swiper-destacados"></div></div><div class=block-title>Categorías</div><div class="row vl-categorias"></div></div></div></div><!-- Popover --><div class="popover popover-links"><div class=popover-inner><div class=list><ul><li><a class="list-button item-link popover-close" href=popup-info>Más información</a></li><li><a class="list-button item-link popover-close" href=popup-calificacion>Calificanos</a></li></ul></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
    .img-establecimiento {
        max-width: 100%;
        max-height: 140px;
    }
    
    .md .buscar-button {
        background-color: white;
    }
    
    .md .searchbar .input-clear-button:after {
        line-height: 48px;
        content: 'search_md';
        opacity: 1;
        font-size: 20px;
        /* font-weight: bold; */
    }
`,
  styleScoped: false
};